import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapActions } from 'vuex';
export default {
  name: 'demo-playground-store-page',
  data: function data() {
    return {
      value: ''
    };
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('d2admin/page', ['keepAliveRemove', 'keepAliveClean'])), mapActions('d2admin/page', ['close', 'closeLeft', 'closeRight', 'closeOther', 'closeAll'])), {}, {
    // 关闭当前
    handleCloseCurrent: function handleCloseCurrent() {
      this.close({
        tagName: this.$route.fullPath
      });
    },
    // 关闭左侧
    handleCloseLeft: function handleCloseLeft() {
      this.closeLeft({
        tagName: this.$route.fullPath
      });
    },
    // 关闭右侧
    handleCloseRight: function handleCloseRight() {
      this.closeRight({
        tagName: this.$route.fullPath
      });
    },
    // 关闭其他
    handleCloseOther: function handleCloseOther() {
      this.closeOther({
        tagName: this.$route.fullPath
      });
    },
    // 清空当前页缓存并刷新此页面
    handleCleanCacheAndRefreshCurrent: function handleCleanCacheAndRefreshCurrent() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.keepAliveRemove(_this.$route.name);

                _context.next = 3;
                return _this.$nextTick();

              case 3:
                _this.$router.replace('/refresh');

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 清空所有的缓存并刷新此页面
    handleCleanCacheAndRefreshAll: function handleCleanCacheAndRefreshAll() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.keepAliveClean();

                _context2.next = 3;
                return _this2.$nextTick();

              case 3:
                _this2.$router.replace('/refresh');

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  })
};